"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSwitch = ToggleSwitch;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
// Main component
// -------------------------------------------------------------------------------------------------

function ToggleSwitch({
  checked = false,
  color,
  disabled,
  onPress,
  testId
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledBase, {
    "aria-checked": checked,
    color: color,
    "data-testid": testId,
    disabled: disabled,
    onClick: onPress,
    role: "switch"
  }, /*#__PURE__*/_react.default.createElement(_styled.StyledAccessibilityLabel, null, checked ? 'On' : 'Off'));
}